import {useBlameAgeColors} from '@github-ui/use-blame-age-color'
import {Box} from '@primer/styled-react'
import React from 'react'

import styles from './BlameAgeLegend.module.css'

export default React.memo(BlameAgeLegend)

function BlameAgeLegend() {
  const colors = useBlameAgeColors()
  return (
    <div aria-hidden className={styles.Box}>
      <span className={styles.Text}>Older</span>
      {colors.map((color, i) => (
        <Box
          key={`blame-recency-color-${i}`}
          sx={{
            backgroundColor: color,
          }}
          className={styles.Box_1}
        />
      ))}
      <span className={styles.Text_1}>Newer</span>
    </div>
  )
}
